export default __webpack_public_path__ + "static/media/trains.f6e8cfb9.png";